// import Profile from "./profile"
// import EditProfile from "./editButton"
// import List from "./list"

// function Account() {
//   return (
//     <div className="flex flex-col min-h-[100vh] max-h-[100vh] w-screen">
//     {/* First Row */}
//     <div className="flex flex-col justify-center items-center flex-1">
//       {/* <div><Profile/></div> */}
//       <div><p className="text-base font-medium">Gayindu Seneviratne</p></div>
//       <div><p  className="text-sm">gayindu@konekt.lk</p></div>
//       <div><p  className="text-xs">+94 71 340 0627</p></div>
     
//     </div>
//     {/* Second Row */}
//     {/* <div className="flex flex-col  flex-1 w-screen border-t-8 border-t-slate-500">
//       <div>
//         <List/>
//       </div>
      
//     </div> */}
//   </div>
//   )
// }

// export default Account

// src/components/Account.tsx
import { useEffect, useState } from 'react';
// import { useAppSelector, useAppDispatch } from '../reduxStore/store';
import { useAppSelector, useAppDispatch } from '../reduxStore/hooks';
import { fetchCurrentUser, UpdateProfilePayload, updateUserProfile, User } from '../models/currentUserSlice';
import LoadingIndicator from '../shared/loadingIndicator';
import Profile from './profile';
import Header from '../shared/header';
// import { useSelector, useDispatch } from 'react-redux';
// import type { RootState } from '../reduxStore/store';
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useSettings } from '../../hooks/useSettings';

const Account = () => {
  const dispatch = useAppDispatch();
  const { user, loading, error } = useAppSelector((state) => state.currentUser);
  const { settings, getSetting } = useSettings();
  const primaryColor = getSetting('primary_color', process.env.REACT_APP_PRIMARY_COLOR || '#1E3A8A');
//   const dispatch = useDispatch();
// const { user, loading, error } = useSelector((state: RootState) => state.currentUser);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  if (loading) return  <LoadingIndicator />;
  if (error) return <div className="text-red-500 text-center mt-4">Error: {error}</div>;
  if (!user) return <div className="text-center mt-4">No user data found</div>;
  
  return (
    <div className="flex flex-col w-full h-screen bg-bright-ashe overflow-y-auto" style={{ '--primary-color': primaryColor } as React.CSSProperties}>
       <div className="fixed top-0 z-10">
        <a href="/homePage">
          <Header icon={<KeyboardArrowLeftIcon />} name="Profile" />
        </a>
      </div>
    <div className="flex flex-col min-h-screen w-full top-20 p-4 pt-16 bg-gray-50">
     
      {/* Profile Header with Avatar */}
      <div className="flex flex-col items-center mb-8">
        <div className="relative mb-4">
          <div className="w-24 h-24 rounded-full flex items-center justify-center text-white text-3xl font-bold" style={{ backgroundColor: 'var(--primary-color)' }}>
            {user.first_name.charAt(0)}{user.last_name.charAt(0)}
          </div>
          {/* {isEditing && (
            <button 
              className="absolute bottom-0 right-0 bg-[#001a70] text-white p-2 rounded-full hover:bg-[#0030a0] transition-colors"
              onClick={() => {}}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
          )} */}
        </div>
        <h1 className="text-2xl font-bold" style={{ color: 'var(--primary-color)' }}>
          {user.first_name} {user.last_name}
        </h1>
        <p className="text-gray-600">{user.email}</p>
      </div>

      {/* Profile Content */}
      <div className="max-w-md mx-auto w-full bg-white rounded-lg shadow-md">
        {/* Header with Edit Button */}
        <div className="px-6 py-4 flex justify-between items-center" style={{ backgroundColor: 'var(--primary-color)' }}>
          <h2 className="text-lg font-semibold text-white">Profile Information</h2>
          {!isEditing && (
            <button
              onClick={() => setIsEditing(true)}
              className="text-white hover:text-gray-200 transition-colors"
              aria-label="Edit profile"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </button>
          )}
        </div>

        {/* Content Area */}
        <div className="p-6">
          {isEditing ? (
            <EditProfileForm 
              user={user} 
              onCancel={() => setIsEditing(false)}
              onSave={(updatedData: UpdateProfilePayload) => { 
                dispatch(updateUserProfile(updatedData));
                setIsEditing(false);
              }}
            />
          ) : (
            <ProfileView user={user} />
          )}
        </div>
      </div>
    </div>
    </div>
  );
};

const ProfileView = ({ user }: { user: User }) => (
  <div className="space-y-4">
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-sm text-gray-500">First Name</p>
        <p className="font-medium text-gray-800">{user.first_name}</p>
      </div>
      <div>
        <p className="text-sm text-gray-500">Last Name</p>
        <p className="font-medium text-gray-800">{user.last_name}</p>
      </div>
    </div>
    <div>
      <p className="text-sm text-gray-500">Email</p>
      <p className="font-medium text-gray-800">{user.email}</p>
    </div>
    <div>
      <p className="text-sm text-gray-500">Phone</p>
      <p className="font-medium text-gray-800">{user.mobile}</p>
    </div>
    {user.dob && (
      <div>
        <p className="text-sm text-gray-500">Date of Birth</p>
        <p className="font-medium text-gray-800">
          {new Date(user.dob).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </p>
      </div>
    )}
  </div>
);

interface EditProfileFormProps {
  user: User;
  onCancel: () => void;
  onSave: (data: UpdateProfilePayload) => void;
}

// src/components/Account.tsx
const EditProfileForm = ({ user, onCancel, onSave }: EditProfileFormProps) => {
  const [formData, setFormData] = useState<UpdateProfilePayload>({
    first_name: user.first_name,
    last_name: user.last_name,
    mobile: user.mobile,
    dob: user.dob || '', 
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value || null }));
  };

  const handleDateChange = (date: Date | null) => {
    setFormData(prev => ({
      ...prev,
      dob: date ? date.toISOString().split('T')[0] : ''
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      first_name: formData.first_name,
      last_name: formData.last_name,
      mobile: formData.mobile,
      dob: formData.dob || null 
    });
  };
  const today = new Date().toISOString().split('T')[0];

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-xl font-bold mb-4">Edit Profile</h2>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm text-gray-500 mb-1">First Name*</label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <div>
          <label className="block text-sm text-gray-500 mb-1">Last Name*</label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>
      </div>

      <div>
        <label className="block text-sm text-gray-500 mb-1">Phone Number*</label>
        <input
          type="tel"
          name="mobile"
          value={formData.mobile}
          onChange={handleChange}
          maxLength={10}
          minLength={10}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div>
        <label className="block text-sm text-gray-500 mb-1">Date of Birth</label>
        <input
          type="date"
          name="dob"
          value={formData.dob || ''}
          onChange={handleChange}
          max={today}
          className="w-full p-2 border rounded"
        />
      </div>

      <div className="flex justify-end space-x-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-white rounded"
          style={{
    backgroundColor: 'var(--primary-color)',
    
  }}
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default Account;